import { render, staticRenderFns } from "./keyValue.vue?vue&type=template&id=7006b3c5&scoped=true"
import script from "./keyValue.vue?vue&type=script&lang=js"
export * from "./keyValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7006b3c5",
  null
  
)

export default component.exports